import axios from '../../../axios';
import downloadCVDTO from '../types/downloadCVDTO';
export const downloadJobsData = (url: string, payload: URLSearchParams) =>
  axios.post(url, payload, {
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    responseType: 'arraybuffer',
  });
export const downloadCandidatesData = (url: string, payload: any) =>
  axios.post(url, payload, {
    headers: {
      'content-type': 'application/json',
    },
    responseType: 'arraybuffer',
  });

export const downloadSubmissionCandidatesData = (url: string, payload: any) =>
  axios.post(url, payload, {
    headers: {
      'content-type': 'application/json',
    },
    responseType: 'arraybuffer',
  });

export const getCVDownloadSettings = () => axios.get('api/plan/feature/usage/CS_CV_DOWNLOAD');
export const downloadCV = (payload: downloadCVDTO) =>
  axios.post('/candidatesearch/api/mapping/download-cvs', payload);
